var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('play',{ref:"play"}),(this.$store.state.taskContainer.showInstructions)?_c('instructions'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }